<template>
  <div class="logo-header" v-if="show">
    <img 
      :src="logoPath" 
      :alt="altText"
      class="logo-image"
    />
  </div>
</template>

<script>
export default {
  name: 'LogoHeader',
  props: {
    // logo图片路径，默认为elm-union.png
    logoPath: {
      type: String,
      default: require('@/assets/logo/elm/elm-unicom.png')
    },
    // alt文本
    altText: {
      type: String,
      default: 'Logo'
    },
    // 是否显示logo
    show: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="less" scoped>
.logo-header {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  padding: 5px 12px;
  
  .logo-image {
    width: 250px;
    height: auto;
    // max-height: 35px;
    object-fit: contain;
    border-radius: 4px;
  }
}
</style>
